import React from 'react';
import { useLanguage, t } from '../context/LanguageContext';

function PrintTraceabilityView({ logs, ingredientBreakdown, ingredientProducts, isIngredientSearchActive, ingredientLotCode, logoUrl, companyName, companyAddress }) {
    const { lang } = useLanguage();
    const printDate = new Date().toLocaleDateString();

    return (
        <div className="print-area">
            {/* Print Header */}
            <div 
                className="d-flex justify-content-between align-items-center mb-3 text-header-font header-wrapper"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                }}
            >
                {/* Left side text */}
                <div style={{ flex: 1, paddingRight: '10px', minWidth: '150px' }}>
                    <p style={{ marginBottom: '0', whiteSpace: 'nowrap' }}>SOP-R-PS Pre-Shipment Review</p>
                    <p style={{ marginBottom: '0', whiteSpace: 'nowrap' }}>REV 1: MAY 2024</p>
                </div>

                {/* Center logo */}
                <div style={{ flex: '0 0 auto', textAlign: 'center' }}>
                    {logoUrl
                        ? <img src={logoUrl} alt="Company Logo" style={{ maxWidth: '250px', maxHeight: '70px', objectFit: 'contain' }} />
                        : <strong style={{ fontSize: 18 }}>{companyName}</strong>
                    }
                </div>

                {/* Right side — company name + address */}
                <div
                    style={{
                        flex: 1,
                        paddingLeft: '10px',
                        minWidth: '150px',
                        textAlign: 'right',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {companyName && <p style={{ marginBottom: 0 }}>{companyName}</p>}
                    {companyAddress && <p style={{ marginBottom: 0 }}>{companyAddress}</p>}
                </div>
            </div>

            {/* Print Date */}
            <p className="text-center">{t('Print Date', 'Fecha de Impresión', lang)}: {printDate}</p>

            {isIngredientSearchActive ? (
                <>
                    {/* Ingredient Breakdown */}
                    {ingredientBreakdown.length > 0 && (
                        <div className="mt-4">
                            <h4>{t('Products Breakdown with ingredient LOT', 'Desglose de Productos con LOT de Ingrediente', lang)}: <b>{ingredientLotCode}</b></h4>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>{t('Product', 'Producto', lang)}</th>
                                        <th>{t('Batch Lot Code', 'Código de Lote', lang)}</th>
                                        <th>{t('Quantity Produced', 'Cantidad Producida', lang)}</th>
                                        <th>{t('Quantity Allocated', 'Cantidad Asignada', lang)}</th>
                                        <th>{t('Quantity in Inventory', 'Cantidad en Inventario', lang)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ingredientBreakdown.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.productName}</td>
                                            <td>{item.batchLotCode}</td>
                                            <td>{item.quantityProduced}</td>
                                            <td>{item.quantityAllocated}</td>
                                            <td>{item.quantityInInventory}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Ingredient Products */}
                    {ingredientProducts.length > 0 && (
                        <div className="mt-4">
                            <h4>{t('Products Distributed to Clients', 'Productos Distribuidos a Clientes', lang)}</h4>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>{t('Customer', 'Cliente', lang)}</th>
                                        <th>{t('Product', 'Producto', lang)}</th>
                                        <th>{t('Batch Lot Code', 'Código de Lote', lang)}</th>
                                        <th>{t('Quantity', 'Cantidad', lang)}</th>
                                        <th>{t('Date', 'Fecha', lang)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ingredientProducts.map((client, index) => (
                                        <tr key={index}>
                                            <td>{client.customer}</td>
                                            <td>{client.productName}</td>
                                            <td>{client.batchLotCode}</td>
                                            <td>{client.quantity}</td>
                                            <td>{new Date(client.date).toLocaleDateString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            ) : (
                <>
                    {/* Default Traceability Logs */}
                    <table className="table table-bordered mt-3">
                        <thead>
                            <tr>
                                <th>{t('Date', 'Fecha', lang)}</th>
                                <th>{t('Product', 'Producto', lang)}</th>
                                <th>{t('Lot Code', 'Código de Lote', lang)}</th>
                                <th>{t('Quantity', 'Cantidad', lang)}</th>
                                <th>{t('Customer', 'Cliente', lang)}</th>
                                <th>{t('Logged By', 'Registrado Por', lang)}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log, index) => (
                                <tr key={index}>
                                    <td>{new Date(log.date).toLocaleDateString()}</td>
                                    <td>{log.Product?.name || 'N/A'}</td>
                                    <td>{log.lotCode}</td>
                                    <td>{log.quantity}</td>
                                    <td>{log.customer}</td>
                                    <td>{log.logged_by || t('Unknown', 'Desconocido', lang)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            <style>
                {`
                    @media print {
                        body * {
                            visibility: hidden;
                        }
                        .print-area, .print-area * {
                            visibility: visible;
                        }
                        .print-area {
                            width: 100%;
                            padding: 20px;
                        }

                        .text-header-font {
                            font-size: 12px;
                            color: #606060;
                        }

                        .header-wrapper {
                            page-break-inside: avoid;
                        }
                    }
                `}
            </style>
        </div>
    );
}



export default PrintTraceabilityView;
